import { SystemFuncArgs } from '@brochington/ecstatic';
import CarnivoreDoc from 'editor/components/CarnivoreDoc';
import CarnivoreSheet from 'editor/components/CarnivoreSheet';
import DomElement from 'editor/components/DomElement';
import { getSheetToScreenTransform } from 'editor/utils/transform';
import { Components } from '../components';
import DOMOverlay from '../components/DOMOverlay';
import Markup from '../components/Markup';
import RemoveBtn from '../components/RemoveBtn';

export const renderRemoveBtnComponents = [
  CarnivoreDoc,
  CarnivoreSheet,
  DOMOverlay,
  DomElement,
  Markup,
  RemoveBtn,
];

export function renderRemoveBtn(args: SystemFuncArgs<Components>): void {
  const { entity, components, world } = args;

  const carnDoc = entity.get(CarnivoreDoc);
  const sheetComp = entity.get(CarnivoreSheet);

  const domOverlay = components.get(DOMOverlay);
  const domElComp = components.get(DomElement);
  const markupComp = components.get(Markup);
  const removeBtn = components.get(RemoveBtn);

  const carnDOMOverlay = domOverlay.domOverlay;
  const container = carnDOMOverlay?.getContainer();

  if (!carnDoc) return;
  const { doc } = carnDoc;

  if (!sheetComp) return;
  const { sheet } = sheetComp;

  if (!removeBtn.mounted) {
    if (carnDOMOverlay) {
      container?.append(domElComp.element);
    }

    removeBtn.mounted = true;
  }

  if (container && markupComp.mkMarkup) {
    const box = markupComp.mkMarkup.getBBox();
    const elWidth = domElComp.element.getBoundingClientRect().width;
    const buttonBuffer = 20;
    const btnOffset = elWidth / 2;

    const transform = getSheetToScreenTransform(world);

    // The 2X here below is to factor in the double size of the current sheet images.
    const rhx = (box.left + (box.right - box.left) / 2) * transform[0];
    const rhy = sheet.height - box.bottom * transform[3] + buttonBuffer;
    const rh = doc.reverseHit(rhx, rhy);
    const { element } = domElComp;

    // Need to compensate for changes in different screen dpi's.
    const pr = window.devicePixelRatio === 1 ? 1 : 2;

    element.style.position = 'absolute';
    element.style.transformOrigin = 'top center';
    element.style.transform = `matrix(${1}, ${0}, ${0}, ${1}, ${
      rh.x / pr - btnOffset
    }, ${rh.y / pr})`; // eslint-disable-line
  }

  if (entity.state === 'destroying') {
    domElComp.element.remove();
  }
}
